export enum AsqSubscriptionType {
  Main,
  Regional,
  Unique,
}
